goog.provide('el8.appchart.letters.dialog.resendLetterWithNewUnreadAlertNotification');

goog.require('el8.service.urls');
goog.require('el8.util.consts');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.data.currUser');


/**
 * A dialog that allows the user to update the unread notification setting for a letter
 */
el8.appchart.letters.dialog.resendLetterWithNewUnreadAlertNotification = (function() {

    var spec;
    var opts;

    var that = new el8.uiwidget.FormDialog({
        title: 'Resend Letter',
        modal: true,
        width: 350,
        autoHeight: true,
        position: 'center',
        showXButton: true,
        contentFn: el8.template.appchart.letters.unreadAlertNotification.resendLetterDialogContent
    });
    
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'unreadAlertInDays',
                selector: ':input[name="unreadAlertInDays"]'
            },
            {
                name: 'includeAttachments',
                selector: ':input[name="includeAttachments"]'
            }
        ]
    });
    
    form.addButton('send', 'Send', function(_form) {
    
        var formOpts = {};
        
        var unreadAlertInDays = _form.getVal('unreadAlertInDays');
        if (unreadAlertInDays !== 'none') {
            formOpts.unreadAlertInDays = unreadAlertInDays;
            var signedUnreadAlertDate = el8.service.tz.today().addDays(unreadAlertInDays*1);
            formOpts.signedUnreadAlertDate = el8.service.tz.asServerFormatDate(signedUnreadAlertDate);
        }
        
        if (_form.getVal('includeAttachments')) {
            formOpts.faxAttachments = true;
        }
        formOpts.successCb = function(updatedLetter) { 
            that.hide(); 
            if (opts.successCb) {
                opts.successCb(updatedLetter);
            }
        };
        spec.resend(formOpts);
        
    }, true);
    form.addButton('print', 'Print Preview', function(_form) {
        window.open(el8.service.urls.get('printPdfLetter', [spec.getLetter()]));
    }, true);
    form.addCancelButton(function(_form) {
        that.hide();
    }, false);
    that.setForm(form);
    
    
    var super_show = that.show;
    that.show = function(_spec, _opts) {
        _opts = _opts || {};
        opts = _opts;
        super_show.call(that);
        spec = _spec;
        $('.letter-summary', that.getContentElt()).html(el8.template.appchart.letters.unreadAlertNotification.letterSummary({
            letter: spec.getLetter().asSoyMap()
        }));
        if (el8.data.currUser.getUnreadLetterNotifications(spec.getLetter().getLetterType())) {
            that.getForm().setVal('unreadAlertInDays', el8.data.currUser.getUnreadLetterNotifications(spec.getLetter().getLetterType()));
        } else {
            that.getForm().setVal('unreadAlertInDays', 'none');
        }
        
        if (spec.getLetter().isSendToPatient()) {
            $('.resend-include-attachments-section').hide();
        } else {
            $('.resend-include-attachments-section').show();
        }

    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        spec = null;
    };

    return that;

})();